import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialogModule } from '@angular/material/dialog';
import { Router } from '@angular/router';
import {
  SearchAutocompleteComponent,
  SearchResult,
} from '../../components/search-autocomplete/search-autocomplete.component';
import { NotificationInboxComponent } from '../../components/notification-inbox/notification-inbox.component';
import { DialogService } from '../../shared/services/dialog/dialog.service';

@Component({
  selector: 'app-projects-header',
  templateUrl: './projects-header.component.html',
  styleUrls: ['./projects-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    MatDialogModule,
    SearchAutocompleteComponent,
    NotificationInboxComponent,
  ],
})
export class ProjectsHeaderComponent {
  private router = inject(Router);
  private dialogService = inject(DialogService);


  onSearch(query: string): void {
    console.log('Search query:', query);
    // Implement search functionality
  }

  onResultSelected(result: SearchResult): void {
    console.log('Selected result:', result);

    // Navigate based on result type
    if (
      'name' in result &&
      'projectId' in result &&
      result.projectId &&
      !('workflowId' in result) &&
      !('stepId' in result)
    ) {
      // This is a project result
      this.router.navigate(['/project', result.projectId]);
    } else if (
      result.projectId &&
      'versionId' in result &&
      (('workflowId' in result && !('stepId' in result)) ||
        ('chunkName' in result && 'stepId' in result && result.versionId))
    ) {
      // This is a notebook or chunk result — both navigate to the project with versionId
      this.router.navigate(['/project', result.projectId], {
        queryParams: { versionId: result.versionId },
      });
    }
  }

  onImport(): void {
    this.dialogService
      .componentsImportProjectDialog()
      .subscribe((result: any) => {
        if (result) {
          console.log('Project imported:', result);
          // Navigate to the imported project
          if (result.projectId) {
            this.router.navigate(['/project', result.projectId]);
          }
        }
      });
  }

  onNewProject(): void {
    this.dialogService.projectCreateDialog().subscribe();
  }
}
